import InputCheckbox from './InputCheckbox';
import InputDate from './InputDate';
import InputNumber from './InputNumber';
import InputRadio from './InputRadio';
import InputRadioItem from './InputRadioItem';
import InputSelect from './InputSelect';
import InputSpinner from './InputSpinner';
import InputText from './InputText';
import InputToggle from './InputToggle';

const Input = InputText;
Input.Checkbox = InputCheckbox;
Input.Date = InputDate;
Input.Number = InputNumber;
Input.RadioItem = InputRadioItem;
Input.Radio = InputRadio;
Input.Select = InputSelect;
Input.Spinner = InputSpinner;
Input.Text = InputText;
Input.Toggle = InputToggle;

export default Input;
